<template>
    <select name="icon" class="form-select form-control">
        <option>เลือก Icon</option>
    </select>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
